export default __webpack_public_path__ + "static/media/inventory.8ee9b37e.jpg";